import { render, staticRenderFns } from "./WsDataTable.vue?vue&type=template&id=dbbc2768&"
import script from "./WsDataTable.vue?vue&type=script&lang=js&"
export * from "./WsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./WsDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VChip,VDataTable,VIcon,VImg})
